import Color from '@/Enums/Color.enum';
import PackageIcon from '@/components/Icons/PackageIcon';
import classNames from 'classnames';

interface IProps {
  productName?: string;
  className?: string;
}

const ProductInventoryEmptyState = ({ productName, className }: IProps) => (
  <div
    className={classNames(
      'flex flex-col items-center justify-center gap-2 p-6 text-center text-[14px]',
      `text-[${Color.Grey}]`,
      className,
    )}
  >
    <PackageIcon />
    {productName ? (
      <p>
        <span className='font-semibold text-[#303030]'>{productName}</span> has no publishers or domains to show
      </p>
    ) : (
      <p>Select a package to see its publishers and domains</p>
    )}
  </div>
);

export default ProductInventoryEmptyState;
